/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from 'react-i18next';
import { formatter } from '@repo/shared';
import { type ColumnDef } from '@tanstack/react-table';

import type { GenerateAudioLeaderboardItem } from '@/api/generated.schemas';
import { ColumnHeader } from '@/components/blocks/data-table/column-header';

export const columns: Array<ColumnDef<GenerateAudioLeaderboardItem>> = [
  {
    accessorKey: 'model',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('overview.model')}
        />
      );
    },
    cell: ({ row }) => row.original.model,
  },
  {
    accessorKey: 'amountOfModelRuns',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('overview.amountOfModelRuns')}
        />
      );
    },
    cell: ({ row }) => row.original.amountOfModelRuns,
  },
  {
    accessorKey: 'cost',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.cost')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.cost(row.original.cost),
  },
  {
    accessorKey: 'time',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.latency')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.time(row.original.time),
  },
  {
    accessorKey: 'wordErrorRate',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.wordErrorRate')}
          enableSorting
        />
      );
    },
    cell: ({ row }) =>
      formatter.metrics.wordErrorRate(row.original.wordErrorRate),
  },
  {
    accessorKey: 'wordsPerMinute',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.wordsPerMinute')}
          enableSorting
        />
      );
    },
    cell: ({ row }) =>
      formatter.metrics.wordsPerMinute(row.original.wordsPerMinute),
  },
];
